import { vaultPostRequest } from '../helpers';
import type { ICheckVideosRequest } from './check-videos-request';
import type { ICheckVideosResponse } from './check-videos-response';
import { checkVideosResponseSchema } from './check-videos-response';

export async function checkVideosApi(body: ICheckVideosRequest): Promise<ICheckVideosResponse> {
  return vaultPostRequest({ path: '/video/check', body, schema: checkVideosResponseSchema });
}
